import axios from 'axios';

class Net {

	get( url, other ) {
		return axios.get( url, other ).then( function(response) {
			let data = response.data;
			return data;
		});
	}

}

let NET = new Net();

export default NET;
